import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faUser, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Button from './Button';

const BranchCard = ({
  name,
  location,
  city,
  postalCode,
  coordinator,
  phone,
  schedule,
  image,
  badgeText,
  badgeColor = 'bg-blue-600',
  whatsappNumber,
  detailLink = '#'
}) => {
  // Format phone number for WhatsApp link (remove spaces, dashes, etc.)
  const formattedPhone = whatsappNumber?.replace(/\D/g, '') || phone?.replace(/\D/g, '');
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden card-shadow">
      <div className="relative">
        <img src={image} alt={name} className="w-full h-48 object-cover" />
        <div className={`absolute top-4 left-4 ${badgeColor} text-white px-3 py-1 rounded-md font-semibold text-sm`}>
          {badgeText}
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-800 mb-3">{name}</h3>
        
        <div className="flex items-start mb-3">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary mt-1 mr-3" />
          <div>
            <p className="text-gray-700">{location}</p>
            <p className="text-gray-700">{city} {postalCode}</p>
          </div>
        </div>
        
        <div className="flex items-center mb-3">
          <FontAwesomeIcon icon={faUser} className="text-primary mr-3" />
          <p className="text-gray-700">Ketua: {coordinator}</p>
        </div>
        
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={faPhoneAlt} className="text-primary mr-3" />
          <p className="text-gray-700">{phone}</p>
        </div>
        
        <div className="border-t border-gray-200 pt-4 mb-4">
          <h4 className="font-bold text-gray-800 mb-2">Jadwal Rutin:</h4>
          <ul className="text-gray-700 space-y-1">
            {schedule.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        
        <div className="flex gap-2">
          <Button href={detailLink} variant="primary" className="flex-grow text-center">
            Lihat Detail
          </Button>
          <a 
            href={`https://wa.me/${formattedPhone}`} 
            className="bg-green-500 text-white w-10 h-10 flex items-center justify-center rounded-md hover:bg-green-600 transition duration-300"
          >
            <FontAwesomeIcon icon={faWhatsapp} className="text-xl" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default BranchCard;
